import { CompanyData } from '../../../types/company-data';
import { CompanyLicenseInformation } from '../../../../license/types/CompanyLicenseInformation';
import { CompanyActionContext } from '../../types/CompanyActionContext';
import { User } from '../../../types/user';
import { Feature } from '@nirvana/shared/constants';

export class CompanyLicensingTabHelper {
  public static shouldDeleteActionBeVisible(
    company: CompanyData,
    companyLicenseInfo: CompanyLicenseInformation | null,
    context: CompanyActionContext
  ) {
    const parentHasFratSubscription = companyLicenseInfo
      ? CompanyLicenseInformation.doesParentCompanyHaveFratSubscription(companyLicenseInfo)
      : CompanyData.doesParentCompanyHaveFratSubscription(company);

    // check for case when updating an existing company
    // hide Remove button for partners having frat subscription editing their own company details
    if (context === CompanyActionContext.MyCompany && CompanyData.hasFratSubscription(company)) {
      return false;
    }

    // hide Remove button for partners having frat subscription editing any other company
    if (parentHasFratSubscription) {
      return false;
    }

    // otherwise, Remove button will be visible for yearly or none payment plan
    return CompanyData.hasNonePaymentPlan(company) || CompanyData.hasYearlyPaymentPlan(company);
  }

  public static shouldAddActionBeVisible(
    company: CompanyData,
    companyLicenseInfo: CompanyLicenseInformation | null,
    context: CompanyActionContext
  ) {
    const parentHasFratSubscription = companyLicenseInfo
      ? CompanyLicenseInformation.doesParentCompanyHaveFratSubscription(companyLicenseInfo)
      : CompanyData.doesParentCompanyHaveFratSubscription(company);

    // check for case when updating an existing company
    // hide Add button for partners having frat subscription editing their own company details
    if (context === CompanyActionContext.MyCompany && CompanyData.hasFratSubscription(company)) {
      return false;
    }

    // hide Add button for partners having frat subscription editing any other company
    if (parentHasFratSubscription) {
      return false;
    }

    // otherwise, Add button will be visible for yearly or none payment plan
    return CompanyData.hasNonePaymentPlan(company) || CompanyData.hasYearlyPaymentPlan(company);
  }

  public static shouldRefreshActionBeVisible(company: CompanyData) {
    return CompanyData.hasYearlyPaymentPlan(company) || CompanyData.hasCloudSecurityForMsp(company);
  }

  public static shouldLogoutButtonBeVisible(loggedUser: User, context: CompanyActionContext, isTextVisible: boolean) {
    return context === CompanyActionContext.Edit
      ? isTextVisible && User.doesLoggedUserHaveManageUsersRight(loggedUser)
      : isTextVisible;
  }

  public static shouldBuyProductButtonBeVisible(context: CompanyActionContext): boolean {
    return context === CompanyActionContext.MyCompany && Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_IN_PRODUCT_BUY]);
  }
}
